// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"58752c9b","258":"b689c3d0","342":"9b92312b","495":"b8afec42","666":"01aa0f38","912":"5c6c1f6c","950":"b2982796"}[chunkId] + ".chunk.js";
};